import { Box } from '@chakra-ui/react';

export const SearchItemWrapper = ({
  children,
  wrapperProps,
}: {
  children: React.ReactNode;
  wrapperProps?: React.ComponentProps<typeof Box>;
}) => {
  return (
    <Box
      gap="12px"
      p="12px"
      alignItems="center"
      borderRadius="xs"
      className="universal--search--item"
      cursor="pointer"
      _hover={{ bg: 'secondary-25' }}
      {...wrapperProps}
    >
      {children}
    </Box>
  );
};
